import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    height: 70,
    position: "sticky",
    top: 0,
    left: 0,
    right: 0,
    background: "#fff",
    paddingInline: 28,
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow:
      " 0px 0px 4px rgba(0, 0, 0, 0.04), 0px 8px 16px rgba(0, 0, 0, 0.08)",
  },
  chatbox:{
    width: 320, 
    border: "1px solid #ddd", 
    borderRadius: "8px", 
    padding: "8px",
    overflowY: "auto",
    maxHeight: "100px", // Fixed height for scrolling
    minHeight: "250px",
  },
  menuLabels: {
    paddingInline: 12,
    dispay: "flex",
    gap: 8,
    alignItems: "center",
  },
}));

export default useStyles;
